import { Facet, isRangeFacet } from './product-facets';

export function timestampFromString( dateString, which ) {
	const parts = dateString.split( '/' );
	parts[ 0 ] = ( parts[ 0 ] < 10
						? '0'
						: '' ) + parts[ 0 ];
	parts[ 1 ] = ( parts[ 1 ] < 10
						? '0'
						: '' ) + parts[ 1 ];
	const date = parts[ 2 ] + '-' + parts[ 0 ] + '-' + parts[ 1 ];
	return '' + ( ( Date.parse( date + ( which === 'from'
													 ? 'T00:00:00'
													 : 'T23:59:59' ) ) ) / 1000 );
}

export function timestampToDateVal( timestamp ) {
	const d = new Date( +timestamp * 1000 );
	//@see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/date
	//console.log('timestampToDateVal', timestamp, d, d.getFullYear() + "-" + (d.getMonth()+1).toString().padStart(2, 0) + '-' + (d.getDate()).toString().padStart(2, 0))
	return d.getFullYear() + "-" + (d.getMonth()+1).toString().padStart(2, 0) + '-' + (d.getDate()).toString().padStart(2, 0);
}

/**
 * @param {string} dateVal
 * @returns {int}
 */
export function dateValToTimestamp( dateVal ) {
	const d = new Date( dateVal );
	/**
	 * we add an offset to make sure the date created is in user's local timezone
	 * to it will be the moment when the new day starts in user's timezone
	 * (by default it would be UTC)
	 */
	//console.log('dateValToTimestamp', dateVal, d, d.getTime(), d.getTimezoneOffset() * 60 * 1000, (d.getTime() + ( d.getTimezoneOffset() * 60 * 1000 ) ) / 1000 );
	return ( d.getTime() + ( d.getTimezoneOffset() * 60 * 1000 ) ) / 1000;
}

export function maybeCastToInt( val ) {
	//@see https://stackoverflow.com/questions/175739/built-in-way-in-javascript-to-check-if-a-string-is-a-valid-number
	return ( val === '' )
			 ? ''
			 : ( isNaN( val )
				  ? val
				  : Number( val ) );
}

export function caseInsensitiveSort( a, b ) {
	return (''+a).localeCompare( ''+b, 'en', { 'sensitivity': 'base' } );
}

export function replaceUrlParams( url, params, separator = '!', tag_suffix = '-Tag' ) {

	const f = url.split('#');
	let result = f[0];
	const fragment = f[1] ?? '';

	const ps = { ...params }; // clone

	if ( typeof ps[ Facet.search_phrase ] === 'undefined' ) {
		/**
		 * make sure search phrase gets removed from the url if it is not being used
		 */
		ps[ Facet.search_phrase ] = '';
	}

	if ( typeof ps[ Facet.search_phrase_item_ids ] !== 'undefined' ) {
		/**
		 * do not show matching product ids in the url
		 */
		delete ps[ Facet.search_phrase_item_ids ];
	}

	Object.entries( ps ).forEach( ( [name, value] ) => {

		const isRange = isRangeFacet( name );
		const isLocation = Facet.location === name;

		if ( value && isRange ) {
			value = (Facet.start_time === name)
					  ? [ timestampToDateVal( value.min ), timestampToDateVal( value.max ) ]
					  : [ value.min, value.max ];
		}

		if ( value && isLocation ) {
			value = [ value.distance, value.zip, value.lat, value.lng ];
		}

		if ( Facet.search_phrase_item_ids === name ) {
			/**
			 * do not show matching product ids in the url
			 */
			return true;  //skipping
		}

		const tagTypeName = name.replace( Facet.tags + '::', '' );

		if ( tagTypeName !== name ) {
			name = tagTypeName + tag_suffix
		}

		if (name === 'Delivery Method Override-Tag'){
			name = 'course-type';
		}

		name = encodeURIComponent( name );

		if ( null === value ) {
			return true; //skipping
			// value = '';
		}

		if ( Array.isArray( value ) && value.length ) {
			if ( !isRange && !isLocation ) {
				value = value.sort( caseInsensitiveSort );
			}
			value = value.join( separator );
		}

		const val = encodeURIComponent( value );

		var pattern = new RegExp( '\\b(' + name + '=).*?(&|#|$)' );

		if ( result.search( pattern ) >= 0 ) {
			result = result.replace( pattern, '$1' + val + '$2' );
		} else {
			result = result.replace( /[?#]$/, '' );
			result = result + ( result.indexOf( '?' ) > 0
									  ? '&'
									  : '?' ) + name + '=' + val;
		}
	} );

	/**
	 * remove empty ps, sort the remaining ones alphabetically
	 */
	const halves = result.split( '?' );
	let parts = [];
	if ( halves.length > 1 ) {
		parts = halves[ 1 ].split( '&' );
		parts = parts.filter( part => {
			const p = part.split( '=' );
			return p.length > 1 && p[ 1 ] !== '';
		} ).sort( caseInsensitiveSort );
	}

	/**
	 * reconstitute url
	 */
	return ( parts.length
				? halves[ 0 ] + '?' + parts.join( '&' )
				: halves[ 0 ]
	) + ( fragment ? '#' + fragment : '' );
}

/**
 * @param searchPhrase string
 * @param item_ids
 * @param onSuccess function
 * @param onFailure function
 */
export function runAjaxSearch( searchPhrase, item_ids, onSuccess, onFailure ) {
	const body = new URLSearchParams();
	body.set( 'search_phrase', searchPhrase );
	if ( Array.isArray( item_ids ) ) {
		item_ids.forEach( ( id ) => body.append( 'item_ids[]', id ) );
	} else if ( typeof item_ids !== 'undefined' && item_ids !== null ) {
		body.set( 'item_ids', item_ids );
	}

	fetch( window.colibri.admin_ajax + '?action=filter_products_by_search_phrase', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		},
		body,
	} )
		.then( ( response ) => {
			if ( !response.ok ) {
				throw response;
			}
			return response.json();
		} )
		.then( ( data ) => {
			if ( typeof onSuccess === 'function' ) {
				onSuccess( data );
			}
		} )
		.catch( ( error ) => {
			if ( typeof onFailure === 'function' ) {
				onFailure( error );
			}
		} );
}

/**
 * @param {object|array|null} filterValue
 * @returns {boolean}
 */
export function isEmptyFilterValue( filterValue ){
	return (typeof filterValue === 'undefined')
		|| (null === filterValue)
		|| (typeof filterValue === 'object' && !Object.entries( filterValue ).length )
		|| (Array.isArray( filterValue ) && !filterValue.length);
}

/**
 * @param {int} itemId
 * @param {string} facetName
 * @returns {*}
 */
export function getProductValue( itemId, facetName ){
	/**
	 * at first, check the first variant
	 */
	let val = window.colibri.index.products[ itemId ][ 'first_variant' ][ facetName ] ?? null;
	if ( null === val ) {
		/**
		 * if field value is not found on first variant, check product itself
		 */
		val = window.colibri.index.products[ itemId ][ facetName ] ?? null;
	}
	return val;
}

// Create a list of day and month names.
var weekdays = [
	"Sunday", "Monday", "Tuesday",
	"Wednesday", "Thursday", "Friday",
	"Saturday"
];

// var months = [
// 	"January", "February", "March",
// 	"April", "May", "June", "July",
// 	"August", "September", "October",
// 	"November", "December"
// ];
//
// // Append a suffix to dates.
// // Example: 23 => 23rd, 1 => 1st.
// function nth(d) {
// 	if (d > 3 && d < 21) return 'th';
// 	switch (d % 10) {
// 		case 1:
// 			return "st";
// 		case 2:
// 			return "nd";
// 		case 3:
// 			return "rd";
// 		default:
// 			return "th";
// 	}
// }
//
// // Create a string representation of the date.
// export function formatDate(date) {
// 	return weekdays[date.getDay()] + ", " +
// 		date.getDate() + nth(date.getDate()) + " " +
// 		months[date.getMonth()] + " " +
// 		date.getFullYear();
// }

export function dateFormatter( step ){
	return {
		/**
		 * 'to' the formatted value. Receives a number.
		 */
		to: function (value) {
			return window.colibri.utils.formatTime( value,  'MM/DD/YYYY' );
		},
		/**
		 * 'from' the formatted value. Receives a string, should return a number.
		 */
		from: function (value) {
			return Number(value);
		}
	}
}

export function formatter( step ){
	return {
		/**
		 * 'to' the formatted value. Receives a number.
 		 */
		to: function (value) {
			return step ? Number(value).toFixed( (step === 1) ? 0: 1)
							: Number(value).toFixed( 1 ) + '0'; // default -- one significant decimal number and `0` -- used for price range
		},
		/**
		 * 'from' the formatted value. Receives a string, should return a number.
		 */
		from: function (value) {
			return Number(value);
		}
	}
}
